// ════════════════════════════════════════════════════════════════════════════════════════════════════════════
//  LAS NOVEDADES DE CADA VERSIÓN, POR AHORA SOLO PARA EL EQUIPO DE BIANGO                              (7-oct-2026)
// ════════════════════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «por ahora las novedades de los commits que subimos a biango, que solo lo vean los superadmin porfa, ya más
//  adelante lo ponemos general». Quien manda es el servidor (backend/services/novedadesDeVersion.js: 403 en
//  /api/version/novedades y sin las automáticas en /api/biango-avisos/vigentes). Esto es para que la pantalla tampoco
//  las enlace ni las pinte a una clínica: la versión del menú se ve pero no lleva a /novedades, la página manda a Inicio,
//  e Inicio no pinta una novedad automática aunque le llegara.
//
//  `user` es el usuario EFECTIVO de AuthContext: al previsualizar como otra persona o rol, `es_superadmin` llega a false
//  a propósito, y ahí tampoco se ven. El interruptor para abrirlas a todas vive en el servidor; la app lo recibe en GET
//  /api/config-cliente (`novedades_para_clinicas`) y hooks/useBranding lo apunta aquí. Sin hooks y sin React, como
//  utils/whatsappBiango: lo cargan de verdad las guardias que montan el menú, Inicio y la página.
let paraLasClinicas = false

export function ponerNovedadesParaLasClinicas(valor) {
  paraLasClinicas = valor === true
  return paraLasClinicas
}

export function veNovedadesDeVersion(user) {
  if (!user || typeof user !== 'object') return false
  return user.es_superadmin === true || paraLasClinicas
}

// Los avisos de Biango que puede ver: todos, o todos menos las novedades automáticas del despliegue (`automatica`, la
// marca que pone el servidor). Los escritos a mano por el equipo de Biango salen siempre.
export function avisosQuePuedeVer(avisos, user) {
  const lista = Array.isArray(avisos) ? avisos : []
  if (veNovedadesDeVersion(user)) return lista
  return lista.filter(a => !(a && (a.automatica === true || a.automatica === 1)))
}
